import React, { useMemo } from 'react';
import CustomBadge from '@/components/CustomBadge';

const FilterBadges = ({
  filters,
  setFilters,
  setTempFilters,
  setActiveFilter,
}) => {
  const filtersHasValues = useMemo(() => {
    return (
      filters.statuses?.length > 0 ||
      filters.types?.length > 0 ||
      filters.terminals?.length > 0 ||
      filters.shippingLines?.length > 0 ||
      filters.originSource?.length > 0 ||
      filters.autobookStatus?.length > 0
    );
  }, [
    filters.statuses,
    filters.types,
    filters.terminals,
    filters.shippingLines,
    filters.originSource,
    filters.autobookStatus,
  ]);

  const handleRemoveFilter = (filterType, value) => {
    const newFilters = {
      ...filters,
      [filterType]: filters[filterType].filter(
        (item) => item.value !== value && item.value !== 'EDITED'
      ),
    };
    setFilters(newFilters);
    setTempFilters(newFilters);
    localStorage.setItem('appointments-filters', JSON.stringify(newFilters));
    setActiveFilter(0);
  };

  if (!filtersHasValues) {
    return null;
  }

  return (
    <div className="relative items-center flex flex-wrap gap-2">
      <span className="text-sm text-black">Filtered by:</span>
      {filters.types.length > 0 &&
        filters.types.map(({ value, label }) => (
          <CustomBadge
            size="small"
            key={label}
            text={`Type: ${label}`}
            onClick={() => handleRemoveFilter('types', value)}
          />
        ))}
      {filters.statuses.length > 0 &&
        filters.statuses
          .filter(({ value }) => value !== 'EDITED')
          .map(({ value, label }) => (
            <CustomBadge
              size="small"
              key={label}
              text={`Status: ${label}`}
              onClick={() => {
                handleRemoveFilter('statuses', value);
              }}
            />
          ))}
      {filters.terminals.length > 0 &&
        filters.terminals.map(({ value, label }) => (
          <CustomBadge
            size="small"
            key={label}
            text={`Terminal: ${label}`}
            onClick={() => handleRemoveFilter('terminals', value)}
          />
        ))}
      {filters.shippingLines.length > 0 &&
        filters.shippingLines.map(({ value, label }) => (
          <CustomBadge
            size="small"
            key={label}
            text={`SSL: ${label}`}
            onClick={() => handleRemoveFilter('shippingLines', value)}
          />
        ))}
      {filters.originSource.length > 0 &&
        filters.originSource.map(({ value, label }) => (
          <CustomBadge
            size="small"
            key={label}
            text={`Origin Source: ${label}`}
            onClick={() => handleRemoveFilter('originSource', value)}
          />
        ))}
      {filters.autobookStatus.length > 0 &&
        filters.autobookStatus.map(({ value, label }) => (
          <CustomBadge
            size="small"
            key={label}
            text={`Autobook Status: ${label}`}
            onClick={() => handleRemoveFilter('autobookStatus', value)}
          />
        ))}
    </div>
  );
};

export default FilterBadges;
